export type XCFieldDefinitionType =
  | "Xcore.XcoreContent.Models.FieldDefinitions.StringFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.NumberFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.BooleanFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.ObjectFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.ArrayFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.SelectFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.AnyFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.RichtextFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.RelationFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.FileFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.ImageFieldDefinition"
  | "Xcore.XcoreContent.Models.FieldDefinitions.VideoFieldDefinition";

export type XCFieldDefinition = {
  $type: XCFieldDefinitionType;
  isOptional?: boolean;
  isLocalized?: boolean;
  allowedContentTypes?: string[];
  // Select field, key and value
  options?: Record<string, string>;
  // Allowed image sizes
  sizes?: Record<string, XCImageSize>;
};

export type XCImageSize = {
  width: number;
  height: number;
};

export type XCForm = {
  name: string;
  rows?: XCRows;
  isTaxonomy?: boolean;
};

export type XCFormFieldType =
  | "textarea"
  | "text"
  | "richtext"
  | "number"
  | "boolean"
  | "image"
  | "video"
  | "file"
  | "select"
  | "relation"
  | "array"
  | "object";

export type XCFormFieldSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type XCRows = Array<Array<XCFormField>>;

export type XCFormFieldMember = {
  type: XCFormFieldType;
  size?: XCFormFieldSize;
  label?: string;
  rows?: XCRows;
  fieldDefinition: XCFieldDefinition;
  member?: XCFormFieldMember;
};

export type XCFormField = {
  name: string;
  type: XCFormFieldType;
  size: XCFormFieldSize;
  label?: string;
  help?: string;
  disabled?: boolean;
  max?: number;
  member?: XCFormFieldMember;
  fieldDefinition: XCFieldDefinition;
};

/** Key is field type to be rendered, value is field value type */
export const formFieldTypeValueType: Record<XCFormFieldType, XCFieldDefinitionType> = {
  textarea: "Xcore.XcoreContent.Models.FieldDefinitions.StringFieldDefinition",
  text: "Xcore.XcoreContent.Models.FieldDefinitions.StringFieldDefinition",
  number: "Xcore.XcoreContent.Models.FieldDefinitions.NumberFieldDefinition",
  boolean: "Xcore.XcoreContent.Models.FieldDefinitions.BooleanFieldDefinition",
  select: "Xcore.XcoreContent.Models.FieldDefinitions.SelectFieldDefinition",
  richtext: "Xcore.XcoreContent.Models.FieldDefinitions.RichtextFieldDefinition",
  relation: "Xcore.XcoreContent.Models.FieldDefinitions.RelationFieldDefinition",
  image: "Xcore.XcoreContent.Models.FieldDefinitions.ImageFieldDefinition",
  video: "Xcore.XcoreContent.Models.FieldDefinitions.VideoFieldDefinition",
  file: "Xcore.XcoreContent.Models.FieldDefinitions.FileFieldDefinition",
  array: "Xcore.XcoreContent.Models.FieldDefinitions.ArrayFieldDefinition",
  object: "Xcore.XcoreContent.Models.FieldDefinitions.ObjectFieldDefinition",
};
